export const Endpoints = {
    ClientServices:
        "https://pf890cf6r9.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://f5ft6xgzwf.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://localhost:44392",
    // "https://f5ft6xgzwf.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://pf890cf6r9.execute-api.us-east-1.amazonaws.com/Prod",
    SubmssionServices:
        "https://8zn1p5xk6i.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://papajo26d5.execute-api.us-east-1.amazonaws.com/Prod",
    // "https://8zn1p5xk6i.execute-api.us-east-1.amazonaws.com/Prod", //"https://pf890cf6r9.execute-api.us-east-1.amazonaws.com/Prod",  //  "https://mut51h27kc.execute-api.us-east-1.amazonaws.com/Prod",

    // "https://8zn1p5xk6i.execute-api.us-east-1.amazonaws.com/Prod",
    //    "https://8zn1p5xk6i.execute-api.us-east-1.amazonaws.com/Prod",
    //    "https://om3ds3ouab.execute-api.us-east-1.amazonaws.com/Prod",
    // "https://papajo26d5.execute-api.us-east-1.amazonaws.com/Prod",
    //    "https://8zn1p5xk6i.execute-api.us-east-1.amazonaws.com/Prod",
    //    "https://om3ds3ouab.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://8zn1p5xk6i.execute-api.us-east-1.amazonaws.com/Prod",
    DataServices: "https://psk3wquggl.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://localhost:44301", //https://psk3wquggl.execute-api.us-east-1.amazonaws.com/Prod
    CaseRecords: "https://chy1if65v6.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://chy1if65v6.execute-api.us-east-1.amazonaws.com/Prod",
    // "https://pwys7gjceh.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://pwys7gjceh.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://rh03bqw4ia.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://pwys7gjceh.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://43bqx0uhk6.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://pwys7gjceh.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://tydzox3wl4.execute-api.us-east-1.amazonaws.com/Prod",

    FileManager: "https://43bqx0uhk6.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://tydzox3wl4.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://43bqx0uhk6.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://43bqx0uhk6.execute-api.us-east-1.amazonaws.com/Prod",
    //"https://tank8vtqlk.execute-api.us-east-1.amazonaws.com/Prod", // "https://43bqx0uhk6.execute-api.us-east-1.amazonaws.com/Prod",
    // "https://43bqx0uhk6.execute-api.us-east-1.amazonaws.com/Prod",
    //ZWICKER "https://tank8vtqlk.execute-api.us-east-1.amazonaws.com/Prod",
    ThirdParty: {
        Existing:
            "https://api-dev.efilemadeeasy.com/api/thirdparty/file/existingpackage",
        New: "https://api-dev.efilemadeeasy.com/api/thirdparty/file/newpackage",
    },
    Tyler: {
        PaymentExternalURL:
            "https://togatest.tylerhost.net/EPayments/Webs/EPayment.aspx",
        PaymentRedirect: "https://localhost:44384",
        PaymentKey: "CJOFS-CAStage-EFSP",
    },
    TylerFileService:
        "https://y41z0oqh6c.execute-api.us-east-1.amazonaws.com/Prod",
};
